import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=212d6f20"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212d6f20')) {
      api.createRecord('212d6f20', component.options)
    } else {
      api.reload('212d6f20', component.options)
    }
    module.hot.accept("./PaymentStep.vue?vue&type=template&id=212d6f20", function () {
      api.rerender('212d6f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/international-architecture-award/components/PaymentStep.vue"
export default component.exports